export default __webpack_public_path__ + "static/media/total_hours.6ae07af4.svg";